import React, { useEffect, useState, } from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import Panel from './Panel.js';
export const HEIGHT = 540;
const Tooltip = (props) => {
    const [position, setPosition] = useState({});
    const height = props.height || HEIGHT;
    useEffect(() => {
        const parentNode = props.parentRef?.current?.getBoundingClientRect();
        const shouldShowOnTop = parentNode.y + parentNode.height + height >= window.innerHeight &&
            parentNode.y >= height;
        props.setShowTooltipOnTop(shouldShowOnTop);
        props.setIsMounted && props.setIsMounted(true);
    }, []);
    useEffect(() => {
        const newPosition = {};
        const parentNode = props.parentRef?.current?.getBoundingClientRect();
        if (props.tooltipToLeft) {
            newPosition.right = `${window.innerWidth - parentNode.x - parentNode.width}px`;
        }
        newPosition.top = `${props.shouldShowOnTop
            ? parentNode.top - height
            : parentNode.top + parentNode.height}px`;
        setPosition(newPosition);
    }, [props.parentRef, props.tooltipToLeft, props.shouldShowOnTop]);
    return (React.createElement(TooltipStyled, { className: "preview-tooltip", style: { ...position, ...props.style }, height: height }, props.children));
};
export default Tooltip;
const TooltipStyled = styled(Panel) `
  position: fixed;
  z-index: 1000;
  background-color: ${THEME.BACKGROUND};
  width: 100vw;
  box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.03);
  max-width: 615px;
  margin-top: -1px;
  * {
    float: none;
  }

  & > div > div.body {
    height: ${(props) => props.height}px !important;
    max-height: ${(props) => props.height}px !important;
    overflow-x: auto;
    font-size: 1rem;
  }
  div.body .body {
    max-height: none;
  }
`;
//# sourceMappingURL=Tooltip.js.map